import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { TabSegment, type TabSegmentItem } from '@/components/shared/redesign';

export type LinkedAccountsTab = 'accounts' | 'invitations';

interface LinkedAccountsTabSegmentProps {
  selectedTab: LinkedAccountsTab;
  accountsCount: number;
  invitationsCount: number;
  onTabChange: (tab: LinkedAccountsTab) => void;
}

export const LinkedAccountsTabSegment: React.FC<LinkedAccountsTabSegmentProps> = React.memo(({
  selectedTab,
  accountsCount,
  invitationsCount,
  onTabChange,
}) => {
  const items = useMemo<TabSegmentItem<LinkedAccountsTab>[]>(
    () => [
      { key: 'accounts', label: 'Accounts', count: accountsCount },
      { key: 'invitations', label: 'Invitations', count: invitationsCount },
    ],
    [accountsCount, invitationsCount],
  );

  return (
    <View style={styles.wrapper}>
      <TabSegment<LinkedAccountsTab>
        items={items}
        selectedKey={selectedTab}
        onChange={onTabChange}
        variant="pill"
      />
    </View>
  );
});

LinkedAccountsTabSegment.displayName = 'LinkedAccountsTabSegment';

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 20,
  },
});
